import { LTime } from '@app/components/date/LTime';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { LDateTime } from '../../../../../../../components/date/LDateTime';

export function VerifiedMatchesTable({
  data,
}: {
  data: auditReports.BcrMatchesReportVerifiedItemDto[];
}) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        {
          id: 'match.datetime',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.matchDatetime',
            defaultMessage: 'Fecha y hora',
          }),
          accessorFn: (row) => {
            const match = row.match as auditReports.MatchResultDto;
            return match?.datetime ? new Date(match.datetime) : null;
          },
          Cell: ({ row }) => {
            const match = row.original.match as auditReports.MatchResultDto;
            if (!match?.datetime) return null;
            return <LDateTime value={match.datetime} showSeconds />;
          },
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
        {
          id: 'match.customId',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.matchCustomId',
            defaultMessage: 'Custom ID',
          }),
          accessorFn: (row) => (row.match as auditReports.MatchResultDto)?.customId || '',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
          size: 150,
        },
        {
          id: 'bcrEntry.name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrName',
            defaultMessage: 'BCR Nombre',
          }),
          accessorFn: (row) => row.bcrEntry.name,
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'match.matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => {
            const match = row.match as auditReports.MatchResultDto;
            return match?.matchedSchedule?.datetime || null;
          },
          Cell: ({ row }) => {
            const match = row.original.match as auditReports.MatchResultDto;
            const matchedSchedule = match?.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.bcrMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          size: 150,
        },
        {
          id: 'bcrEntry.datetime',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime',
            defaultMessage: 'BCR Entry Time',
          }),
          accessorFn: (row) => (row.bcrEntry?.datetime ? new Date(row.bcrEntry.datetime) : null),
          Cell: ({ row }) => {
            if (!row.original.bcrEntry?.datetime) return null;
            return (
              <Chip
                label={<LTime value={row.original.bcrEntry.datetime} showSeconds />}
                size="small"
                color="info"
                variant="outlined"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
      ]}
    />
  );
}
